import createAction from './_createAction';

const ADD_NEW_REPORT = createAction('ADD_NEW_REPORT');

export default ADD_NEW_REPORT;
